"use strict";

var _preact = require("preact");
module.exports = function (_ref) {
  var i18n = _ref.i18n;
  return (0, _preact.h)("div", {
    className: "uppy-Provider-loading"
  }, (0, _preact.h)("span", null, i18n('loading')));
};